import React, { Fragment, useEffect, useState } from 'react';

import {
  ExpandLess,
  ExpandMore,
  ErrorOutline,
  Map,
  Person,
  PostAdd,
  MonetizationOn,
  FormatListBulleted,
  Visibility,
  VerifiedUser
} from '@material-ui/icons';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Collapse, ListSubheader, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Badge from 'components/Badge/Badge';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';

import { wsGet, wsCreate, wsUpdate } from 'services/WService';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { Link } from 'react-router-dom';
import Modal from './ModalError/Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';

const useStyles = makeStyles((theme) => ({
  listItem: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  nested: {
    paddingLeft: theme.spacing(4),
    cursor: 'default'
  },
  containerPermissions: {
    maxHeight: '30Vh',
    border: '2px solid #d5d5d9',
    borderRadius: '10px',
    overflowY: 'auto',
    marginBottom: '8px',
    '&::-webkit-scrollbar-track': {
      borderRadius: '10px'
    },
    '&::-webkit-scrollbar': {
      width: '7px',
      backgroundColor: '#f1f1f1'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#d5d5d9',
      borderRadius: '10px'
    },
    '&::-webkit-scrollbar:horizontal': {
      display: 'none'
    }
  }
}));

export default function OpenZone({ zones, showNotify, reload }) {
  const [errorZones, setErrorZones] = useState({});
  const [open, setOpen] = useState(false);
  const [model, setOpenModal] = useModal();
  const [notify, showNotifyModal] = useToasty();
  let [nameError, setNameError] = useState('');

  async function openZone(id) {
    setOpen(true);
    let response = await wsCreate('prog/zone-open', { base_zone_id: id });
    if (response.success) {
      setErrorZones({ success: true });
      reload();
      setOpen(false);
      showNotify(response.message);
    } else {
      setOpen(false);
      if (!!response.data) {
        setErrorZones({ ...response.data, success: false, idZone: id });
      }
      showNotify(response.message, 'error');
    }
  }

  async function checkZones(id) {
    let response = await wsGet('prog/zone-open', id);
    if (response.success) {
      showNotify(response.message);
      setErrorZones({ success: true });
    } else {
      showNotify(response.message, 'error');
      if (!!response.data) {
        setErrorZones({ ...response.data, success: false, idZone: id });
      }
    }
  }

  async function updateBPartners(id) {
    let response = await wsUpdate('base/business-partner', id, { frozenFor: 'N' });
    if (response.success) {
      showNotify(response.message);
      openZone(errorZones.idZone);
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <Card>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpenModal}
          showNotify={showNotifyModal}
          errorZones={errorZones}
          nameError={nameError}
        />
      ) : undefined}
      <CardHeader>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ margin: 0, fontSize: '18px', marginRight: '15px' }}>
            <b>Apertura de zonas</b>
          </span>
          <div>
            {zones.map((item) => {
              return (
                <Badge
                  key={item.id}
                  style={{
                    marginRight: '10px',
                    cursor: 'pointer',
                    backgroundColor: item.open
                      ? '#43a047'
                      : errorZones.idZone === item.id
                      ? '#a5190f'
                      : '#f44336'
                  }}
                  onClick={() => {
                    if (item.open !== null || open) {
                      checkZones(item?.open?.id);
                      return;
                    }
                    openZone(item.id);
                  }}
                >
                  {item.description}
                </Badge>
              );
            })}
          </div>
          {errorZones.success === false ? (
            <b
              style={{
                color: '#ff8100',
                borderLeft: '3px solid red',
                paddingLeft: '10px'
              }}
            >
              {errorZones.tipo_cambio === null || errorZones.tipo_cambio?.Rate == '0'
                ? 'No se encontro el tipo de cambio de hoy'
                : ''}
            </b>
          ) : undefined}
        </div>
      </CardHeader>
      {!errorZones.success && errorZones.success != undefined ? (
        <CardBody>
          <GridContainer>
            {errorZones.business_partners?.length === 0 ? undefined : (
              <GridItem xs={12} lg={4} xl={4}>
                <ContenList
                  title="Socio Negocio"
                  Icon={Person}
                  data={errorZones.business_partners}
                  update={updateBPartners}
                  primary="CardName"
                  secondary="CardCode"
                  linkRef="/admin/socio-negocio/datos-maestros/clientes/"
                  keyField="id"
                  conditionVerify={{ value: 'frozenFor', equal: 'Y' }}
                  permission={{
                    show: ConstantPermissions.BASE_BUSINESS_PARTNERS_SHOW,
                    verify: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_OPEN_VALIDATE_BP
                  }}
                />
              </GridItem>
            )}
            {errorZones.addresses?.length === 0 ? undefined : (
              <GridItem xs={12} lg={4} xl={4}>
                <ContenList
                  title="Direcciones"
                  Icon={Map}
                  data={errorZones.addresses}
                  primary="Address2"
                  secondary="CardCode"
                  tercero="CardName"
                  linkRef="/admin/socio-negocio/datos-maestros/clientes/"
                  keyField="base_business_partner_id"
                  /* tag="#direcciones" */
                  permission={{
                    show: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_STORE,
                    verify: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_STORE
                  }}
                />
              </GridItem>
            )}

            {errorZones.products?.length === 0 ? undefined : (
              <GridItem xs={12} lg={4} xl={4}>
                <ContenList
                  title="Productos"
                  Icon={FormatListBulleted}
                  data={errorZones.products}
                  primary="ItemName"
                  secondary="ItemCode"
                  permission={{
                    show: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_STORE,
                    verify: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_STORE
                  }}
                />
              </GridItem>
            )}

            {errorZones.stocks?.length === 0 ? undefined : (
              <GridItem xs={12} lg={4} xl={4}>
                <ContenList
                  title="Stocks"
                  Icon={PostAdd}
                  data={errorZones.stocks}
                  primary="ItemName"
                  secondary="ItemCode"
                  permission={{
                    show: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_STORE,
                    verify: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_STORE
                  }}
                />
                <Badge
                  color="danger"
                  style={{
                    cursor: 'pointer',
                  }}
                  onClick={() => {setOpenModal({});setNameError('Stock');}}
                >
                  Mostrar productos sin stock
                </Badge>
              </GridItem>
            )}

            {errorZones.price?.length === 0 ? undefined : (
              <GridItem xs={12} lg={4} xl={4}>
                <ContenList
                  title="Precios"
                  Icon={MonetizationOn}
                  data={errorZones.price}
                  primary="ItemName"
                  secondary="ItemCode"
                  permission={{
                    show: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_STORE,
                    verify: ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_STORE
                  }}
                />
              </GridItem>
            )}
          </GridContainer>
        </CardBody>
      ) : undefined}
    </Card>
  );
}

function ContenList({
  title, // ? título de la card (tarjeta)
  Icon, // ? icono del label
  data, // ? data para mapear en los labels
  update = undefined, // ? ejecutar funcion de actualizacion
  primary, // ? titulo del label
  secondary, // ? subtitulo del label
  tercero = '', // ? valor extapara el label
  linkRef = '', // ? link de redirección
  keyField = '', // ? campo con el ID para redirigir en la url
  tag = '', // ? tag de url (especial socio negocio)
  conditionVerify = {}, // ? recibe el campo a evaluar y equal representa la igualdad
  permission = {} // ? objeto con los permisos correspondientes
}) {
  const classes = useStyles();
  const [itemSelect, setItemSelect] = useState({});

  return (
    <div className={classes.containerPermissions}>
      <List
        component="div"
        subheader={<ListSubheader component="div">{title}</ListSubheader>}
        className={classes.listItem}
      >
        {data?.map((obj) => {
          return (
            <Fragment key={obj.id}>
              <ListItem
                button
                onClick={() => {
                  if (itemSelect.id === obj.id) {
                    setItemSelect({ ...obj, open: !itemSelect.open });
                  } else {
                    setItemSelect({ ...obj, open: true });
                  }
                }}
                style={{ paddingTop: 0, paddingBottom: 0 }}
              >
                <ListItemIcon onClick={() => navigator.clipboard.writeText(obj[secondary])}>
                  <Tooltip title="Copiar código">
                    <Icon />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary={obj[primary]}
                  secondary={`${obj[secondary]}${!!tercero ? ` - ${obj[tercero]}` : ''}`}
                />
                {itemSelect.id === obj.id && itemSelect.open ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse
                in={itemSelect.id === obj.id && itemSelect.open}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {obj.errors.map((error, i) => (
                    <ListItem key={i} button className={classes.nested} dense>
                      <ListItemIcon>
                        <ErrorOutline color="error" />
                      </ListItemIcon>
                      <ListItemText primary={error} />
                      {!!linkRef ? (
                        <ListItemIcon>
                          <AllowedGuard permission={permission.show}>
                            <Link
                              to={`${linkRef}${obj[keyField]}${!!tag ? tag : ''}`}
                              target="_blank"
                            >
                              <Visibility style={{ color: '#9c27b0' }} />
                            </Link>
                          </AllowedGuard>
                          {obj[conditionVerify.value] == conditionVerify.equal && update ? (
                            <AllowedGuard permission={permission.verify}>
                              <VerifiedUser
                                onClick={() => update(obj.id)}
                                style={{ color: '#07c149', marginLeft: '15px', cursor: 'pointer' }}
                              />
                            </AllowedGuard>
                          ) : undefined}
                        </ListItemIcon>
                      ) : undefined}
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            </Fragment>
          );
        })}
      </List>
    </div>
  );
}
